import { LANGUAGE, STORAGE_CONST } from '@common/constants'
import { getSessionState } from '@common/utils'

export const getContentLanguage = () => getSessionState(STORAGE_CONST.SAVED_LANGUAGE) || LANGUAGE.EN
